<template>
  <div class="md:max-w-xl lg:max-w-2xl content-block mb-16" :class="{ 'mx-auto': this.$props.center }">
    <div class="text-lg lg:text-2xl uppercase">{{ row.title }}</div>
    <div v-for="(person, i) in people" :key="i" class="flex justify-between text-lg lg:text-xl">
      <div class="w-2/5"><strong>{{ person.role }}</strong></div>
      <div class="w-3/5">
        <router-link v-if="person.slug" :to="localeLink(person.slug)" class="underline">{{ person.name }}</router-link>
        <span v-else>{{ person.name }}</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'BaseArticleDepartmentRow',
  props: {
    row: Object,
    center: Boolean
  },
  computed: {
    people () {
      return this.row ? this.row.people : []
    }
  }
}
</script>
